// This function allow to reference async chunks
__webpack_require__.u = function(chunkId) {
	// return url for filenames not based on template
	if (chunkId === 206) return "static/chunks/206-fbe20750bf29da9e.js";
	// return url for filenames based on template
	return "static/chunks/" + ({"146":"datadog_browser_logs","340":"layout__client_site_chrome_ui","367":"layout__minimal","748":"datadog_browser_rum"}[chunkId] || chunkId) + "." + {"146":"594085561864a715","205":"4cc40c0e1f4cb0f2","319":"0cbc2894a3f1b950","340":"c29fd9f08c828565","367":"0f4713b8083a70e6","639":"d0dc2f6d47c67d6f","748":"63e726de322da2a3"}[chunkId] + ".js";
};